import React, { useState } from "react";
import emailjs from '@emailjs/browser';
import "./Contact.css";

const Contact = () => {
  const services = [
    "Individual Counselling in Nagercoil", 
    "Prenatal Counselling Services", 
    "Premarital Counselling in Tamil Nadu", 
    "Couples Counselling & Marriage Therapy", 
    "Child & Adolescent Counselling", 
    "Family Counselling Services",
    "Group Therapy & Support Sessions", 
    "Geriatric & Senior Citizen Counselling", 
    "Career Counselling & Guidance",
    "Academic Guidance & Student Counseling", 
    "Stress Management Therapy", 
    "Grief Counseling & Bereavement Support",
    "Mandala Art Therapy Workshop"
  ];

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: '',
    timePreference: 'Morning',
    sessionType: 'Offline'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (submitStatus) setSubmitStatus('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('sending');

    try {
      await emailjs.send(
        'service_x0yq0x9',
        'template_u98iw5v',
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          service: formData.service,
          message: formData.message,
          time_preference: formData.timePreference,
          session_type: formData.sessionType,
          date: new Date().toLocaleDateString(),
          to_email: 'servitecouncelingcenter@gmail.com'
        },
        'hLcC56cE274aJ2bs8'
      );

      setSubmitStatus('success');
      setFormData({
        name: '',
        phone: '',
        email: '',
        service: '',
        message: '',
        timePreference: 'Morning',
        sessionType: 'Offline'
      });

      setTimeout(() => setSubmitStatus(''), 5000);

    } catch (error) {
      console.error('Email sending failed:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(''), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="elite-contact-section">
      <div className="elite-contact-container">
        {/* Header Section */}
        <div className="elite-contact-header">
          <div className="header-decoration">
            
           
          </div><br></br>
          <h1 className="elite-contact-title">
            Book Our Professional Counselling Session 
          </h1>
          <p className="elite-contact-subtitle">
            Begin your mental wellness journey with certified counselling services in Tamil Nadu - 
            Schedule your appointment with our expert therapist for personalized mental health care
          </p>
        </div>

        {/* Main Content */}
        <div className="elite-contact-content">
          <div className="elite-contact-grid">
            {/* Contact Information */}
            <div className="elite-contact-info">
              <div className="info-card">
                <div className="info-header">
                  <div className="info-icon">
                    <i className="bi bi-heart-pulse"></i>
                  </div>
                  <h3>Contact Information</h3>
                  <p>Reach out to start your mental health journey with certified experts </p>
                </div>
                
                <div className="info-items">
                  <div className="info-item">
                    <div className="item-icon">
                      <i className="bi bi-telephone-fill"></i>
                    </div>
                    <div className="item-content">
                      <h4>Counselling Helpline Number</h4>
                      <p>+91 8148 600 633</p>
                      <span>Direct line to certified mental health professional</span>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="item-icon">
                      <i className="bi bi-envelope-fill"></i>
                    </div>
                    <div className="item-content">
                      <h4>Professional Email Address</h4>
                      <p>servitecounselingcentre@gmail.com</p>
                      <span>Raisingesponse guaranteed within 24 hours</span>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="item-icon">
                      <i className="bi bi-clock-fill"></i>
                    </div>
                    <div className="item-content">
                      <h4>Therapy Session Hours</h4>
                      <div className="timing-details">
                        <div className="timing">
                          <strong>Morning Session</strong>
                          <span>9:30 AM - 12:00 PM</span>
                        </div>
                        <div className="timing">
                          <strong>Evening Session</strong>
                          <span>4:00 PM - 7:00 PM</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="item-icon">
                      <i className="bi bi-geo-alt-fill"></i>
                    </div>
                    <div className="item-content">
                      <h4>Counseling Centre Location</h4>
                     
                      <span>Servite Counselling Centre, Near Holy Cross College, Vattakarai, Nagercoil - 629004, Tamilnadu, India</span>
                    </div>
                  </div>
                </div>

                <div className="info-features">
                  <div className="feature-item">
                    <i className="bi bi-shield-check"></i>
                    <span>100% Confidential Therapy Sessions</span>
                  </div>
                  <div className="feature-item">
                    <i className="bi bi-laptop"></i>
                    <span>Online & Offline Counselling Available</span>
                  </div>
                  <div className="feature-item">
                    <i className="bi bi-star-fill"></i>
                    <span>Certified Professional Counsellor</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Appointment Form */}
            <div className="elite-appointment-form">
              <div className="form-card">
                <div className="form-header">
                  <h3>Schedule Your Professional Counselling Session</h3>
                  <p>
                    Complete the appointment form below and our certified mental health professional 
                    will contact you to confirm your therapy session in Nagercoil
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="elite-form">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter your full name for appointment booking"
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number *</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="+91 8148 600 633 - Counselling Helpline"
                        required
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email Address</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="your@email.com for appointment confirmation"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="service">Professional Service Interested In *</label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleInputChange}
                      required
                      disabled={isSubmitting}
                    >
                      <option value="">Select a professional counselling service</option>
                      {services.map((service, index) => (
                        <option key={index} value={service}>{service}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="sessionType">Therapy Session Type</label>
                      <select
                        id="sessionType"
                        name="sessionType"
                        value={formData.sessionType}
                        onChange={handleInputChange}
                        disabled={isSubmitting}
                      >
                        <option value="Offline">Offline Session (In-person Counseling in Nagercoil)</option>
                        <option value="Online">Online Session (Professional Video Call Therapy)</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="timePreference">Preferred Therapy Time</label>
                      <select
                        id="timePreference"
                        name="timePreference"
                        value={formData.timePreference}
                        onChange={handleInputChange}
                        disabled={isSubmitting}
                      >
                        <option value="Morning">Morning Session (9:30 AM - 12:00 PM)</option>
                        <option value="Evening">Evening Session (4:00 PM - 7:00 PM)</option>
                        <option value="Any">Any Available Professional Time Slot</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Additional Mental Health Information</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      placeholder="Please share any specific mental health concerns, therapy goals, or questions you'd like our certified counsellor to know about before your session..."
                      rows="4"
                      disabled={isSubmitting}
                    ></textarea>
                  </div>

                  {/* Status Messages */}
                  {submitStatus === 'sending' && (
                    <div className="status-message sending">
                      <i className="bi bi-arrow-repeat"></i>
                      <span>Processing your professional counselling appointment request...</span>
                    </div>
                  )}
                  
                  {submitStatus === 'success' && (
                    <div className="status-message success">
                      <i className="bi bi-check-circle"></i>
                      <span>
                        Appointment request successfully submitted! Our certified mental health professional 
                        will contact you within 24 hours to confirm your therapy session.
                      </span>
                    </div>
                  )}
                  
                  {submitStatus === 'error' && (
                    <div className="status-message error">
                      <i className="bi bi-exclamation-circle"></i>
                      <span>
                        Unable to send appointment request. Please call our counselling helpline directly 
                        at +91 8148 600 633 for immediate assistance.
                      </span>
                    </div>
                  )}

                  <button 
                    type="submit" 
                    className="elite-submit-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <i className="bi bi-hourglass-split"></i>
                        Processing Your Therapy Appointment...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-calendar-check"></i>
                        Book Appointment
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* NEW: Separate Disclaimer Section */}
      <div className="separate-disclaimer-section">
        <div className="elite-contact-container">
          <div className="separate-disclaimer-card">
            <div className="separate-disclaimer-header">
              <i className="bi bi-info-circle"></i>
              <h4>Important Information</h4>
            </div>
            <div className="separate-disclaimer-content">
              <p>
                <strong>Please Note:</strong> This is a counselling centre providing psychological support, 
                therapy, and mental wellness services. We are <strong>NOT</strong> an emergency medical 
                treatment centre or a hospital. In case of medical emergencies
                or life-threatening situations, please contact:
              </p>
              
              <div className="separate-emergency-contacts">
                <div className="separate-emergency-item">
                  <i className="bi bi-phone"></i>
                  <div>
                    <strong>Medical Emergency Helpline:</strong>
                    <span>108 (Ambulance Service)</span>
                  </div>
                </div>
                <div className="separate-emergency-item">
                  <i className="bi bi-hospital"></i>
                  <div>
                    <strong>Suicide Prevention Helpline:</strong>
                    <span>9152987821 </span>
                  </div>
                </div>
                <div className="separate-emergency-item">
                  <i className="bi bi-shield-exclamation"></i>
                  <div>
                    <strong>Emergency Services:</strong>
                    <span>Visit your nearest hospital emergency department</span>
                  </div>
                </div>
              </div>
              
              <p className="separate-disclaimer-note">
                Our services include professional counselling, psychotherapy, and mental health support 
                for emotional, psychological and relational wellbeing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;